import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { ApproveExternalProviderPaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const approveExternalProviderPayment = createApiThunk<void, ApproveExternalProviderPaymentBody>(
  "externalProviderPayments/approveExternalProviderPayment",
  async (body, { extra: { adminRepository } }) => {
    return adminRepository!.approveExternalProviderPayment(body);
  },
);

export const resetApproveExternalProviderPayment = createAction("externalProviderPayments/resetApproveExternalProviderPayment");
